<div class="container">
  <h2 class="titulo error">Desculpe, essa página não existe ...</h2>
</div>
